import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Shield: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 46 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.1155 30.0604C37.9155 38.0604 18.2822 36.3937 9.11549 34.5604C1.61549 32.3937 -8.28451 25.2604 12.1155 14.0604C32.5155 2.8604 39.9488 5.72706 41.1155 8.5604C43.9488 12.3937 48.3155 22.0604 43.1155 30.0604Z"
        fill="#0BA95E"
        fillOpacity="0.2"
      />
      <path
        d="M35.4111 3.88731C33.5113 3.68516 31.6416 3.26255 29.8395 2.62801C28.1859 2.04373 26.5996 1.28378 25.108 0.361185C24.7188 0.12493 24.2722 0 23.8168 0C23.3615 0 22.9149 0.12493 22.5257 0.361185L22.5242 0.362602C21.0329 1.28444 19.4472 2.04391 17.7941 2.62801C15.9925 3.26241 14.1232 3.68503 12.2239 3.88735C11.6138 3.94983 11.0486 4.23649 10.6378 4.69182C10.2269 5.14715 9.99966 5.73874 10 6.35203V13.7144C10.001 16.4308 10.7279 19.0975 12.1056 21.4387C13.4832 23.7798 15.4615 25.7103 17.8356 27.0302L22.6114 29.6845C22.9793 29.8913 23.3941 30 23.8161 30C24.2381 30 24.653 29.8913 25.0208 29.6845L29.798 27.0302C32.1722 25.7103 34.1504 23.7798 35.5281 21.4387C36.9057 19.0975 37.6326 16.4308 37.6336 13.7144V6.35203C37.6341 5.73895 37.407 5.14751 36.9964 4.6922C36.5859 4.23689 36.021 3.95009 35.4111 3.88731ZM29.4562 12.3928L24.142 18.0612C23.8897 18.331 23.5419 18.4914 23.1729 18.5082C22.804 18.525 22.443 18.3969 22.1672 18.1512L18.9787 15.317C18.6979 15.0674 18.5278 14.7165 18.5058 14.3415C18.4837 13.9665 18.6115 13.598 18.8611 13.3173C19.1107 13.0365 19.4616 12.8663 19.8366 12.8443C20.2116 12.8222 20.58 12.95 20.8608 13.1996L23.0183 15.1163L27.3887 10.4554C27.5213 10.3141 27.6814 10.2014 27.8592 10.1243C28.037 10.0472 28.2286 10.0072 28.4224 10.0069C28.6987 10.007 28.9689 10.0879 29.1998 10.2396C29.4307 10.3913 29.6122 10.6072 29.7221 10.8607C29.8319 11.1141 29.8653 11.3942 29.818 11.6664C29.7708 11.9386 29.645 12.1911 29.4562 12.3928Z"
        fill="#1B3029"
      />
    </svg>
  )
})

Shield.displayName = 'Shield'
